// 首页tips
export const openLits = state => state.openLits
// 规划咨询模块弹出
export const proposalLayer = state => state.proposalLayer
export const studyLayer = state => state.studyLayer
export const planLayer = state => state.planLayer
// 投资管理弹出
export const touziLayer = state => state.touziLayer
// 是否项目组成员
export const ayth = state => state.ayth



// WEBPACK FOOTER //
// ./src/store/getters.js